export default __webpack_public_path__ + "static/media/socials.b57875c8.png";